import React, { useState, useEffect } from 'react';
import { makeStyles, useTheme } from "@material-ui/core/styles";

import Navigation from "./views/general/Navigation";
import Header from "./views/general/Header";
import Profile from "./views/general/Profile";
import UserManagement from "./views/settings/UserManagement";
import Settings from "./views/settings/Settings";
import UserSettings from "./views/settings/UserSettings";
import Credits from "./views/credits/Credits";
import PotentialRefinancing from "./views/credits/PotentialRefinancing";
import Credit from "./views/credits/Credit";
import CreditTipp from "./views/credits/CreditTipp";
import CreditWizard from "./views/credits/CreditWizard";
import Compares from "./views/compares/Compares";
import NotificationSettings from "./views/settings/NotificationSettings";
// disabled because of dependency problem with "@react-pdf/renderer"
// import Compare from "./views/compares/Compare";


const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(2),
  },
  progress: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    margin: "auto",
  },
  toolbar: theme.mixins.toolbar,
}));



const App = (props) => {
  const theme = useTheme();
  const classes = useStyles();
  const [menuOpen, setMenuOpen] = useState(false);







  const renderContent = () => {
    if (!props && !props.view)
      return <></>;
    switch (props.view) {
      case "Profile":
        return (
          <Profile />
        );
      case "UserManagement":
        return <UserManagement />;
      case "Credits":
        return <Credits isArchiveView={false} />;
      case "CreditsArchive":
        return <Credits isArchiveView={true} />;
      case "PotentialRefinancing":
        return <PotentialRefinancing />;
      case "Compares":
        return <Compares />;
      // disabled because of dependency problem with "@react-pdf/renderer"
      // case "Compare":
      //   return <Compare id={props.match.params.id} />;
      case "Credit":
        return <Credit id={props.match.params.id} view={props.match.params.view} />;
      case "CreditTipp":
        return <CreditTipp id={props.match.params.id} view={props.match.params.view} />;
      case "CreditWizard":
        return <CreditWizard id={props.match.params.id} view={props.match.params.view} />;
      case "Settings":
        return <Settings />;
      case "NotificationSettings":
        return <NotificationSettings />;
      case "UserSettings":
        return <UserSettings />;
    }
  }

  return (
    <>
      <Header
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
      />
      <div className={classes.container}>
        <Navigation
          menuOpen={menuOpen}
          setMenuOpen={setMenuOpen}
        />

        <main className={classes.content}>
          <div className={classes.toolbar} />

          {renderContent()}
        </main>
      </div>
    </>
  );
};

export default App;